var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopDummyImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9812 5.72375L18.85 1.19625C18.7112 0.64 18.2112 0.25 17.6375 0.25H2.36375C1.79 0.25 1.29 0.64 1.15 1.19625L0.01875 5.72375C0.00625 5.7725 0 5.82375 0 5.875C0 7.5975 1.33125 9 2.96875 9C3.92 9 4.76875 8.52625 5.3125 7.79125C5.85625 8.52625 6.705 9 7.65625 9C8.6075 9 9.45625 8.52625 10 7.79125C10.5438 8.52625 11.3912 9 12.3438 9C13.2963 9 14.1437 8.52625 14.6875 7.79125C15.2313 8.52625 16.0787 9 17.0312 9C18.6687 9 20 7.5975 20 5.875C20 5.82375 19.9937 5.7725 19.9812 5.72375Z",
    fill: "#FB607F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0312 10.25C16.18 10.25 15.3712 9.99001 14.6875 9.51501C13.32 10.4663 11.3675 10.4663 10 9.51501C8.6325 10.4663 6.68 10.4663 5.3125 9.51501C4.62875 9.99001 3.82 10.25 2.96875 10.25C2.355 10.25 1.77625 10.1063 1.25 9.86127V16.5C1.25 17.19 1.81 17.75 2.5 17.75H7.5V12.75H12.5V17.75H17.5C18.19 17.75 18.75 17.19 18.75 16.5V9.86127C18.2237 10.1063 17.645 10.25 17.0312 10.25Z",
    fill: "#FB607F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopDummyImage);
export default __webpack_public_path__ + "static/media/shop-dummy-image.08e7aee730dfe0b3c13b667c6899ba0b.svg";
export { ForwardRef as ReactComponent };